import { formatFreeDays, getDurationTime } from '@/utils';
import { ReadStatus } from './enums';
import { TFunction } from 'i18next';

export interface AssetSearch {
  asset_uuid: string;
  vehicle_stock_number: string;
  zone_name: string;
  vehicle_make: string;
  vehicle_model_code: string;
  vehicle_model: string;
  vehicle_year: number;
  vehicle_battery?: string | null;
  vehicle_level?: string | null;
  dtc?: Dtc[] | null;
  lat?: number | null;
  lon?: number | null;
  markedAsFound?: boolean;
  sale_year?: number | null;
  sale_number?: number | null;
  sale_lane?: number | null;
  sale_run?: number | null;
  work_order?: string | null;
  vehicle_color?: string | null;
  assoc_timestamp?: string;
  time_in_zone?: string;
  has_dtc_optedout?: boolean;
}

export type Asset = {
  asset_uuid: string;
  time_since_assoc?: string;
  storageDays?: string;
  zone_name: string;
  vehicle_make?: string;
  vehicle_model?: string | null;
  vehicle_model_code?: string | null;
  vehicle_year?: number;
  vehicle_body?: string | null;
  vehicle_transmission?: string | null;
  vehicle_door_count?: string | null;
  vehicle_level?: string | null;
  vehicle_series?: string | null;
  dtc?: Dtc[] | null;
  seller_id?: string | null;
  vehicle_odometer?: string | null;
  vehicle_color?: string | null;
  vehicle_stock_number?: string | null;
  lat?: number | null;
  lon?: number | null;
  custom_metadata?: any | AIBACustomMetadata;
  markedAsFound?: boolean;
  sale_year?: number | null;
  sale_number?: number | null;
  sale_lane?: number | null;
  sale_run?: number | null;
  assoc_timestamp?: string;
  time_in_zone?: string;
  work_order?: string | null;
} & AIBACustomMetadata;

export type AIBACustomMetadata = {
  siteNumber?: number;
  make?: string;
  model?: string;
  color?: string;
  code?: string;
  freeDays?: number;
  additionalServices?: string;
  remarks?: string;
  storageDays?: string;
};

export type Dtc = {
  code: string;
  description: string;
  status: Array<keyof typeof ReadStatus>;
  scanned_date: string;
};

export enum BatteryLevelsEnum {
  NORMAL = 'Normal',
  LOW = 'Low',
  EXTREMELY_LOW = 'Extremely Low',
  NO_VOLTAGE_AVAILABLE = 'No Voltage Available',
}

export const isAsset = (object: any): object is Asset => {
  if (!object) return false;
  return 'asset_uuid' in object;
};

export const checkAssetTypeValue = (
  key: any,
  value: any,
  t: TFunction,
): any => {
  switch (key) {
    case 'freeDays': {
      return formatFreeDays(value);
    }
    case 'dtc':
      return `${value ? value.map((dtc: { code: string }) => dtc.code) : ''}`;
    case 'time_in_zone':
      return value ? `${getDurationTime(+value * 1000, t)}` : '';
    default:
      break;
  }
  switch (value) {
    case null:
      return '';

    case true:
      return t('global.Yes');

    case false:
      return t('global.No');

    default:
      return value;
      break;
  }
};
